import Store from '../Store';

const routes = [
    {
        path: '/',
        component: () => import('../Pages/Home.vue'),
        name: 'Dashboard'
    },
    // {
    //     path: '/login',
    //     component: () => import('../Pages/Login.vue'),
    //     name: 'Login',
    //     beforeEnter: (to, from, next) => {
    //         // if (Store.getters['user/getSession']) {
    //         //     next('/validateEmail')
    //         // }
    //         next();
    //     },
    // },
    {
        path: '/validateEmail',
        component: () => import('../Pages/ValidateEmail.vue'),
        name: 'validate_email',
        beforeEnter: (to, from, next) => {
            if (!Store.getters['user/getSession']) {
                next('/')
            }
            // if (Store.getters['token/tokenValidate']) {
            //     next('/')
            // }
            next();
        },
        
    },
    /*{
       path: '/:name',
       component: () => import('../Pages/StoreList.vue'),
       name: 'show_store_list',
       props: true
    },*/
    {
       path: '/store/list/:id?',
       component: () => import('../Pages/StoreList.vue'),
       name: 'show_store_list',
       props: true
    },
    {
        path: '/store/product/:id?',
        component: () => import('../Pages/StoreProductView.vue'),
        name: 'show_store_product'
    },
    {
        path: '/confirmed',
        component: () => import('../Pages/Sucess.vue'),
        name: 'sucess_page'
    },
    {
        path: '/product/list/:id?',
        component: () => import('../Pages/ProductList.vue'),
        name: 'show_product_list',
        props: true
    },

    {
       path: '/collection/list',
       component: () => import('../Pages/CollectionList.vue'),
       name: 'show_collection_list',
       props: true
    },
    
    {
        path: '/product/:id/:product_type?',
        component: () => import('../Pages/ProductView.vue'),
        name: 'show_product'
    },    
    {
       path: '/favorite/list',
       component: () => import('../Pages/FavoriteList.vue'),
       name: 'show_favorite_list',
       props: true,
       beforeEnter: (to, from, next) => {
        if (!Store.getters['user/getSession']) {
            window.location.href = '/auth/login'; 
            return;
        }
        // if (!Store.getters['token/tokenValidate']) {
        //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
        // } 
            next();
        },  
    },
    {
        path: '/product/rank/:type?',
        component: () => import('../Pages/ProductRank.vue'),
        name: 'show_product_rank',
        props: true
    },

    {
        path: '/filter-products/:search/:category_id?',
        component: () => import('../Pages/FilterProduct.vue'),
        name: 'filter_product',
        props: true
    },  
    
    {
        path: '/promotion/list/:id?',
       component: () => import('../Pages/PromotionList.vue'),
       name: 'show_promotion_list',
       props: true
    },

    {
        path: '/productTcg/list',
        component: () => import('../Pages/ProductTcgList.vue'),
        name: 'show_product_tcg_list',
        props: true
    },

    {
        path: '/ranking',
        component: () => import('../Pages/Ranking.vue'),
        name: 'Ranking',
        /*beforeEnter: (to, from, next) => { 
        if (!Store.getters['token/tokenValidate']) {
            next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
        }
            next();
        },*/
    },
    {
        path: '/cart',
        component: () => import('../Pages/Cart.vue'),
        name: 'Cart',
        beforeEnter: (to, from, next) => {
            if (!Store.getters['user/getSession']) {
                window.location.href = '/auth/login'; 
            return;
            } 
            // if (!Store.getters['token/tokenValidate']) {
            //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
            // }
            next();
        }   
    },
    {
        path: '/checkout',
        component: () => import('../Pages/Checkout.vue'),
        name: 'Checkout',
         beforeEnter: (to, from, next) => {
            console.log(Store.getters['cart/cartExist'], "carrinhjo exite")
            if (!Store.getters['user/getSession'] || !Store.getters['cart/cartExist']) {
                window.location.href = '/auth/login'; 
            return;
            }
            // if (!Store.getters['token/tokenValidate']) {
            //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
            // }
            next();
        }    
    },
    {
        path: '/supplier',
        component: () => import('../Pages/Supplier.vue'),
        name: 'Supplier',
        beforeEnter: (to, from, next) => { 
        // if (!Store.getters['token/tokenValidate']) {
        //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
        // }
            next();
        },
    },
    {
        path: '/classifieds',
        component: () => import('../Pages/Classified.vue'),
        name: 'Classified',
        /*beforeEnter: (to, from, next) => { 
        if (!Store.getters['token/tokenValidate']) {
            next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
        }
        next();
        },*/
    },

    {
        path: '/shopkeepers',
        component: () => import('../Pages/Shopkeeper.vue'),
        name: 'Shopkeeper',
        /*beforeEnter: (to, from, next) => { 
        if (!Store.getters['token/tokenValidate']) {
            next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
        }
            next();
        },*/
    },

    {
        path: '/questions',
        component: () => import('../Pages/Question.vue'),
        name: 'Question',
        /*beforeEnter: (to, from, next) => { 
        if (!Store.getters['token/tokenValidate']) {
            next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
        }
            next();
        },*/
    },

    // {
    //     path: '/productTcg',
    //     component: () => import('../Pages/ProductTcg.vue'),
    //     name: 'ProductTcg',
    //     beforeEnter: (to, from, next) => { 
    //     if (!Store.getters['token/tokenValidate']) {
    //         next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
    //     }
    //         next();
    //     },
    // },

    {
        path: '/my-store/:store_id/product-create',
        component: () => import('../Components/checkout/Product.vue'),
        name: 'ProductCreate'
    },


    {
        path: '/address',
        component: () => import('../Pages/Address.vue'),
        name: 'Address',
        beforeEnter: (to, from, next) => { 
        // if (!Store.getters['token/tokenValidate']) {
        //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
        // }
            next();
        },
    },

    {
        path: '/classified/:id?',
        component: () => import('../Pages/AdView.vue'),
        name: 'show_classified'
    },  

    {
        path: '/my-account',
       component: () => import('../Pages/profile/Dashboard.vue'),
       name: 'my_account',
       props: true,
       beforeEnter: (to, from, next) => {
        if (!Store.getters['user/getSession']) {
            window.location.href = '/auth/login'; 
            return;
        }
        // if (!Store.getters['token/tokenValidate']) {
        //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
        // }
        next();
        },
    },

    {
       path: '/my-account/order-view/:id?',
       component: () => import('../Pages/profile/OrderView.vue'),
       name: 'my_account_order_view',
       props: true,
       beforeEnter: (to, from, next) => {
        if (!Store.getters['user/getSession']) {
            window.location.href = '/auth/login'; 
            return;
        }
        // if (!Store.getters['token/tokenValidate']) {
        //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
        // }
        next();
        }
    
    },

    {
        path: '/my-store/company-info',
        component: () => import('../Pages/company/CompanyInfo.vue'),
        name: 'company_info',
        props: true,
        beforeEnter: (to, from, next) => {
         if (!Store.getters['user/getSession']) {
             window.location.href = '/auth/login'; 
             return;
         }
         // if (!Store.getters['token/tokenValidate']) {
         //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
         // }
         next();
         }
     },

    {
        path: '/my-store/list',
       component: () => import('../Pages/store/MyStoreList.vue'),
       name: 'my_store_list',
       props: true,
       beforeEnter: (to, from, next) => {
        if (!Store.getters['user/getSession']) {
            window.location.href = '/auth/login'; 
            return;
        }
        // if (!Store.getters['token/tokenValidate']) {
        //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
        // }
        next();
        }
    },

    {
       path: '/my-store/:store_id/orders',
       component: () => import('../Pages/store/Orders.vue'),
       name: 'my_store_orders',
       props: true,
       meta: {
        breadcrumb: 'Pedidos'
       },
       beforeEnter: (to, from, next) => {
        if (!Store.getters['user/getSession']) {
            window.location.href = '/auth/login'; 
            return;
        }
        // if (!Store.getters['token/tokenValidate']) {
        //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
        // }
        next();
        }
    },

    {
        path: '/my-store/:store_id/returned-orders',
        component: () => import('../Pages/store/ReturnedOrders.vue'),
        name: 'my_store_returned_orders',
        props: true,
        beforeEnter: (to, from, next) => {
         if (!Store.getters['user/getSession']) {
             window.location.href = '/auth/login'; 
             return;
         }
         // if (!Store.getters['token/tokenValidate']) {
         //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
         // }
         next();
         }
     },

     {
        path: '/my-store/:store_id/detail-orders/:order_id',
        component: () => import('../Pages/orderCancel/OrderDetail.vue'),
        name: 'my_store_detail_orders',
        props: true,
        beforeEnter: (to, from, next) => {
            if (!Store.getters['user/getSession']) {
            window.location.href = '/auth/login'
            return
            }
            next()
        }
     },

     {
        path: '/my-store/:store_id/detail-status/:order_id',
        component: () => import('../Pages/orderCancel/OrderStatusDetail.vue'),
        name: 'my_order_detail',
        props: true,
        beforeEnter: (to, from, next) => {
            if (!Store.getters['user/getSession']) {
            window.location.href = '/auth/login'
            return
            }
            next()
        }
     },

     {
        path: '/my-store/:store_id/new-order/:order_id',
        component: () => import('../Pages/orderCancel/OrderNew.vue'),
        name: 'my_order_new',
        props: true,
        beforeEnter: (to, from, next) => {
            if (!Store.getters['user/getSession']) {
            window.location.href = '/auth/login'
            return
            }
            next()
        }
     },

     {
        path: '/my-store/:store_id/cancel-orders/:order_id',
        component: () => import('../Pages/orderCancel/OrderCancel.vue'),
        name: 'my_order_cancel',
        props: true,
        beforeEnter: (to, from, next) => {
            if (!Store.getters['user/getSession']) {
            window.location.href = '/auth/login'
            return
            }
            next()
        }
     },

     {
        path: '/my-store/:store_id/concluid-order/:order_id',
        component: () => import('../Pages/orderCancel/OrderConcluid.vue'),
        name: 'my_order_concluid',
        props: true,
        beforeEnter: (to, from, next) => {
            if (!Store.getters['user/getSession']) {
            window.location.href = '/auth/login'
            return
            }
            next()
        }
     },

     {
        path: '/my-store/:store_id/order-defense/:order_id',
        component: () => import('../Pages/orderCancel/OrderDefense.vue'),
        name: 'my_order_defense',
        props: true,
        beforeEnter: (to, from, next) => {
            if (!Store.getters['user/getSession']) {
            window.location.href = '/auth/login'
            return
            }
            next()
        }
     },

     {
        path: '/my-store/:store_id/products',
        component: () => import('../Pages/store/Products.vue'),
        name: 'my_store_products',
        props: true,
        meta: {
            breadcrumb: 'Produtos'
        },
        beforeEnter: (to, from, next) => {
         if (!Store.getters['user/getSession']) {
             window.location.href = '/auth/login'; 
             return;
         }
         
         // if (!Store.getters['token/tokenValidate']) {
         //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
         // }
         next();
         }
     },

     {
        path: '/my-store/personalize-store/:store_id',
        component: () => import('../Pages/store/PersonalizeStore.vue'),
        name: 'my_store_personalize',
        props: true,
        meta: {
            breadcrumb: 'Produtos'
        },
        beforeEnter: (to, from, next) => {
         if (!Store.getters['user/getSession']) {
             window.location.href = '/auth/login'; 
             return;
         }
         // if (!Store.getters['token/tokenValidate']) {
         //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
         // }
         next();
         }
     },

     {
        path: '/my-store/config-store/:store_id',
        component: () => import('../Pages/store/ConfigStore.vue'),
        name: 'my_store_config',
        props: true,
        meta: {
            breadcrumb: 'Produtos'
        },
        beforeEnter: (to, from, next) => {
         if (!Store.getters['user/getSession']) {
             window.location.href = '/auth/login'; 
             return;
         }
         // if (!Store.getters['token/tokenValidate']) {
         //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
         // }
         next();
         }
     },

     {
        path: '/my-store/:store_id/products/Cards',
        component: () => import('../Pages/store/ProductCardList.vue'),
        name: 'my_store_products_cards',
        props: true,
        meta: {
            breadcrumb: 'Produtos'
        },
        beforeEnter: (to, from, next) => {
         if (!Store.getters['user/getSession']) {
             window.location.href = '/auth/login'; 
             return;
         }
         // if (!Store.getters['token/tokenValidate']) {
         //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
         // }
         next();
         }
     },


     {
        path: '/my-store/:store_id/products/Tcg',
        component: () => import('../Pages/store/ProductTcgList.vue'),
        name: 'my_store_products_tcg',
        props: true,
        meta: {
            breadcrumb: 'Produtos'
        },
        beforeEnter: (to, from, next) => {
         if (!Store.getters['user/getSession']) {
             window.location.href = '/auth/login'; 
             return;
         }
         // if (!Store.getters['token/tokenValidate']) {
         //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
         // }
         next();
         }
     },

     {
        path: '/my-store/:store_id/products/CardsBra',
        component: () => import('../Pages/store/ProductCardBraList.vue'),
        name: 'my_store_products_bra',
        props: true,
        meta: {
            breadcrumb: 'Produtos'
        },
        beforeEnter: (to, from, next) => {
         if (!Store.getters['user/getSession']) {
             window.location.href = '/auth/login'; 
             return;
         }
         // if (!Store.getters['token/tokenValidate']) {
         //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
         // }
         next();
         }
     },

     {
        path: '/my-store/:store_id/product-register',
        component: () => import('../Pages/store/ProductRegister.vue'),
        name: 'my_store_product_register',
        props: true,
        beforeEnter: (to, from, next) => {
         if (!Store.getters['user/getSession']) {
             window.location.href = '/auth/login'; 
             return;
         }
         // if (!Store.getters['token/tokenValidate']) {
         //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
         // }
         next();
         }
     },

     {
        path: '/my-store/:store_id/project-management',
        component: () => import('../Pages/order/ProjectManagement.vue'),
        name: 'my_store_project_management',
        props: true,
        beforeEnter: (to, from, next) => {
         if (!Store.getters['user/getSession']) {
             window.location.href = '/auth/login'; 
             return;
         }
         // if (!Store.getters['token/tokenValidate']) {
         //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
         // }
         next();
         }
     },

     {
        path: '/my-store/:store_id/project-management',
        component: () => import('../Pages/order/ProjectManagement.vue'),
        name: 'my_store_project_management',
        props: true,
        beforeEnter: (to, from, next) => {
         if (!Store.getters['user/getSession']) {
             window.location.href = '/auth/login'; 
             return;
         }
         // if (!Store.getters['token/tokenValidate']) {
         //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
         // }
         next();
         }
     },

     {
        path: '/my-store/:store_id/ad-list',
        component: () => import('../Pages/classified/AdList.vue'),
        name: 'ads_list',
        props: true,
        beforeEnter: (to, from, next) => {
         if (!Store.getters['user/getSession']) {
             window.location.href = '/auth/login'; 
             return;
         }
         // if (!Store.getters['token/tokenValidate']) {
         //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
         // }
         next();
         }
     },

     {
        path: '/my-store/:store_id/ad-create',
        component: () => import('../Pages/classified/AdCreate.vue'),
        name: 'ads_create',
        props: true,
        beforeEnter: (to, from, next) => {
         if (!Store.getters['user/getSession']) {
             window.location.href = '/auth/login'; 
             return;
         }
         // if (!Store.getters['token/tokenValidate']) {
         //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
         // }
         next();
         }
     },

     {
        path: '/my-store/:store_id/ad-trash',
        component: () => import('../Pages/classified/AdTrash.vue'),
        name: 'ads_trash',
        props: true,
        beforeEnter: (to, from, next) => {
         if (!Store.getters['user/getSession']) {
             window.location.href = '/auth/login'; 
             return;
         }
         // if (!Store.getters['token/tokenValidate']) {
         //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
         // }
         next();
         }
     },

     {
        path: '/my-store/:store_id/ad-payment',
        component: () => import('../Pages/payment/FeaturedPayment.vue'),
        name: 'ads_payment',
        props: true,
        beforeEnter: (to, from, next) => {
         if (!Store.getters['user/getSession']) {
             window.location.href = '/auth/login'; 
             return;
         }
         // if (!Store.getters['token/tokenValidate']) {
         //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
         // }
         next();
         }
     },

     {
        path: '/my-store/:store_id/payment-pix',
        component: () => import('../Pages/payment/PixOption.vue'),
        name: 'payment_pix',
        props: true,
        beforeEnter: (to, from, next) => {
         if (!Store.getters['user/getSession']) {
             window.location.href = '/auth/login'; 
             return;
         }
         // if (!Store.getters['token/tokenValidate']) {
         //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
         // }
         next();
         }
     },

     {
        path: '/my-store/:store_id/payment-cart',
        component: () => import('../Pages/payment/CartOption.vue'),
        name: 'payment_cart',
        props: true,
        beforeEnter: (to, from, next) => {
         if (!Store.getters['user/getSession']) {
             window.location.href = '/auth/login'; 
             return;
         }
         // if (!Store.getters['token/tokenValidate']) {
         //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
         // }
         next();
         }
     },


    {
        path: '/my-store/besaler',
       component: () => import('../Pages/store/BeSaler.vue'),
       name: 'be_a_saler',
       props: true,
    },

    {
        path: '/my-store/dashboard/:store_id?',
       component: () => import('../Pages/store/Dashboard.vue'),
       name: 'my_store_dashboard',
       props: true,
       beforeEnter: (to, from, next) => {
        if (!Store.getters['user/getSession']) {
            window.location.href = '/auth/login'; 
            return;
        }
        // if (!Store.getters['token/tokenValidate']) {
        //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
        // }
        next();
        }
    },

    {
        path: '/my-store/order-view/:id?/:store_id?',
       component: () => import('../Pages/store/OrderView.vue'),
       name: 'my_store_order_view',
       props: true,
       beforeEnter: (to, from, next) => {
        if (!Store.getters['user/getSession']) {
            window.location.href = '/auth/login'; 
            return;
        }
        // if (!Store.getters['token/tokenValidate']) {
        //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
        // }
        next();
        }
    
    },

    {
        path: '/complaints/:id?',
       component: () => import('../Pages/Complaint.vue'),
       name: 'complaint',
       props: true,
       beforeEnter: (to, from, next) => {
        if (!Store.getters['user/getSession']) {
            window.location.href = '/auth/login'; 
            return;
        }
        // if (!Store.getters['token/tokenValidate']) {
        //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
        // }
        next();
        }
    
    },

    {
        path: '/my-store/complaints/:store_id/:id?',
       component: () => import('../Pages/ComplaintStore.vue'),
       name: 'complaint_store',
       props: true,
       beforeEnter: (to, from, next) => {
        if (!Store.getters['user/getSession']) {
            window.location.href = '/auth/login'; 
            return;
        }
        // if (!Store.getters['token/tokenValidate']) {
        //     next('/validateEmail'); // Permite o acesso à página do carrinho se o cliente estiver ativado
        // }
        next();
        }
    },

    {
        path: '/my-store/:store_id/wallet',
        component: () => import('../Components/store/Wallet.vue'),
        name: 'wallet',
        props: true,
        meta: {
            breadcrumb: 'Finanças'
        },
    },

    {
        path: '/my-store/:store_id/bankAccount',
        component: () => import('../Pages/wallet/BankAccount.vue'),
        name: 'bankAccount',
        props: true,
        meta: {
            breadcrumb: 'Finanças'
        },
    },

    {
        path: '/my-store/:store_id/bankCardCredit',
        component: () => import('../Pages/wallet/CreateBankCardCredit.vue'),
        name: 'bankCardCredit',
        props: true,
        meta: {
            breadcrumb: 'Finanças'
        },
    },


    {
        path: '/:store_slug?',
        component: () => import('../Pages/StoreList.vue'),
        name: 'slug_store_list',
        props: true
    },

    {
        path: '/bra-center/:store_id?',
        component: () => import('../Components/store/BraCenter.vue'),
        name: 'BraCenter',
        props: true
    },

    {
        path: '/bra-center-list',
        component: () => import('../Components/store/BraCenterList.vue'),
        name: 'BraCenterList',
        props: true
    },

    {
       path: '/products-cards-bra-center',
       component: () => import('../Pages/ProductListBraCenter.vue'),
       name: 'productsCardsBraCenter',
       props: true,
    },

    {
        path: '/brand/:brand',
        component: () => import('../Pages/Brand.vue'),
        name: 'Brand',
    },

    {
        path: '/league/:name',
        component: () => import('../Pages/League.vue'),
        name: 'League',
    },
    
    {
        path: '/hide-menu',
        component: () => import('../Components/SideMenuMobile.vue'),
        name: 'HideMenu',
    }

    
    // {
    //     path: '/plans/:renew?',
    //     component: () => import('../Pages/Plan.vue'),
    //     name: 'Planos'
    // },
   
    // {
    //     path: '/shipping/view/:id',
    //     component: () => import('../Pages/Shipping/Show.vue'),
    //     name: 'Ver Remessa',
    //     props: true
    // },
    // {
    //     path: '/profile',
    //     component: () => import('../Pages/Profile.vue'),
    //     name: 'Perfil'
    // }
]


export default routes;